module.exports = __webpack_public_path__ + "img/plus.45d31948.svg";